<div class="w-100 h-500 d-flex align-items-center justify-content-center h4">
  {{ "downloadTicket.description" | translate: {"shortCode" : shortCode} }} <span (click)="downloadPdf(shortCode)" class="text-info cursor-pointer">&nbsp;{{ "downloadTicket.link" | translate }}</span>
</div>